import { AppLightTooltip, AppUseIcon } from 'components/ui';
import { useEffect, useState } from 'react';

import CheckIcon from '@mui/icons-material/Check';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { t } from 'utilities/TranslationUtils';

const AppCopyText = ({ text, dataTest = 'copyButton', className = '' }: { text?: string; dataTest?: string; className?: string }) => {
  const [valueToCopy, setValueToCopy] = useState<string>('');
  const [isValueCopied, setIsValueCopied] = useState<boolean>(false);

  useEffect(() => {
    if (isValueCopied) {
      setTimeout(() => {
        setValueToCopy(valueToCopy);
        setIsValueCopied(false);
      }, 1050);
    }
  }, [isValueCopied]);

  return (
    <>
      {text && (
        <AppLightTooltip className='tooltip_icon' title={`${isValueCopied ? t('copied') : t('copy')}`} placement='top'>
          <CopyToClipboard
            text={text}
            onCopy={() => {
              setIsValueCopied(true);
              setValueToCopy(text);
            }}
          >
            <button
              data-test={dataTest}
              className={`btn btn-transparent p-0 d-flex align-items-center justify-content-center ml-2 ${className}`}
            >
              {isValueCopied ? <CheckIcon className='font-18' /> : <AppUseIcon name='CopyIcon' width='17' height='16' />}
              <span className='sr-only'>{isValueCopied ? t('copied') : t('copy')}</span>
            </button>
          </CopyToClipboard>
        </AppLightTooltip>
      )}
    </>
  );
};

export default AppCopyText;
